// extracted by mini-css-extract-plugin
module.exports = {"inputRadioButton":"_107X0"};